import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import styles from '../../assets/stylesheets/pages/searches/filter_group.module.scss'

const FilterGroup = props => {
  const {
    name,
    children,
    isOpen,
    toggleOpenFilters,
    isExpanded,
    toggleExpandedFilters
  } = props

  const toggleOpen = event => {
    event.preventDefault()
    toggleOpenFilters(name)
  }
  const toggleExpanded = event => {
    event.preventDefault()
    toggleExpandedFilters(name)
  }

  const defaultOptionNumber = 5

  return (
    <details
      className={cx(
        styles['filter-group'],
        isOpen && styles['filter-group--open']
      )}
      open={isOpen}
      id={`${name.replace(/\s+/g, '-').toLowerCase()}-filter-group`}
    >
      <summary
        className={styles['filter-group__title']}
        onClick={toggleOpen}
      >
        {name}
      </summary>
      <div
        className={cx(
          styles['filter-group__filters'],
          isExpanded && 'filter-group--expanded'
        )}
      >
        {isExpanded ? children : children.slice(0, defaultOptionNumber)}
      </div>
      {children.length > defaultOptionNumber &&
        <button
          className={styles['filter-group__toggle']}
          onClick={toggleExpanded}
        >
          {isExpanded ? 'Show Less' : 'Show More'}
        </button>}
    </details>
  )
}
FilterGroup.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.array.isRequired
}

export default FilterGroup
